import React, { FC } from 'react'
import { Layout, Nav, Button, Avatar, Badge, Dropdown, RadioGroup, Radio,Typography, Toast } from '@douyinfe/semi-ui'
import { IconBell, IconHelpCircle } from '@douyinfe/semi-icons'
import Breadcrumb from '../breadcrumb'
import Tags from '../tags'
import { useZxContext } from '../../../../zxContext'
import '../../index.scss'
import { useNavigate } from 'react-router-dom'

const { Header } = Layout

const Index = () => {
	const {locale,changeLocale, setLogin, setUserinfo, userinfo, setTags} = useZxContext()

	const selectLocale = (locale) => {
		changeLocale(locale)
		localStorage.setItem('zx_config_locale', locale)
	}


	return (
		<Header className="layout-header">
			<Nav
				mode="horizontal"
				header={<Breadcrumb />}
				footer={
					<>
						<Typography.Title heading={5} style={{marginRight:10}}>{userinfo.unit}</Typography.Title>
						{/* <Badge count={0} type="danger">
							<Button
								theme="borderless"
								icon={<IconBell />}
								style={{
									color: 'var(--semi-color-text-2)',
									marginRight: '12px'
								}}
							/>
						</Badge> */}

						<Dropdown
							render={
								<Dropdown.Menu>
									{/* <Dropdown.Item>个人中心</Dropdown.Item>
									<Dropdown.Item>个人设置</Dropdown.Item> */}
									<Dropdown.Item onClick={()=>{
										setUserinfo({})
										setTags([])
										setLogin(false)
										Toast.success('退出成功')
									}}>退出登录</Dropdown.Item>
								</Dropdown.Menu>
							}
						>
							<Avatar color="orange" size="small">
								{userinfo.unit[1]}
							</Avatar>
						</Dropdown>

						<RadioGroup type="button" defaultValue={locale} style={{ marginLeft: '20px' }}>
							<Radio value={'zh_CN'} onChange={() => selectLocale('zh_CN')}>
								中文
							</Radio>
							<Radio value={'en_GB'} onChange={() => selectLocale('en_GB')}>
								EN
							</Radio>
						</RadioGroup>
					</>
				}
			></Nav>
			<Tags />
		</Header>
	)
}

export default Index
